import React, { Component } from 'react';

class Resume extends Component {
  render() {
    return (
      <div className="right">
        <div className="right-inner">
          <div className="introduction">
            <h4>Intro</h4>
            <div className="content">
              {/* I&#39;m  */}
              <p className="intro-p">A decade of solutions-driven experience in building scalable and performant applications, specializing in web tier engineering and architecture.</p>
              <p className="intro-p">I enjoy researching and solving problems in engineering and design, and feel right at home as a front end engineer. I take pride in my methodical process to arrive at a solution.</p>
              <span className="intro-p job-pls">I&#39;m currently looking for an opportunity as a front-end architect in Hyderabad.</span>
              <small>Third party recruiters, Please excuse.</small>
            </div>
          </div>
          <div className="skills">
            <h4>Skills</h4>
            <div className="content">
              <div className="skill-category">
                <strong>Languages: &nbsp;</strong>
                <span>JavaScript (ES6), Java, C#, PHP, HTML5, CSS3</span>
              </div>
              <div className="skill-category">
                <strong>Libraries &amp; Frameworks: &nbsp;</strong>
                <span>React, Redux, Angular 4, RxJS, Meteor, Node, Express, GraphQL, React Native, Cordova</span>
              </div>
              <div className="skill-category">
                <strong>Databases: &nbsp;</strong>
                <span>MySQL, MongoDB, Cassandra</span>
              </div>
              <div className="skill-category">
                <strong>Tools: &nbsp;</strong>
                <span>Git, Command Line, Gulp, Grunt, Postman, Trello, Compass, Workbench</span>
              </div>
            </div>
          </div>
          <div className="education">
            <h4>Education</h4>
            <div className="content">
              <div className="university"><a href="http://www.northeastern.edu/" target="_blank" rel="noopener noreferrer">Jawaharlal Nehru Technological University</a></div>
              {/* <div className="college"><a href="http://www.ccis.northeastern.edu/" target="_blank" rel="noopener noreferrer">Computer Science and Engineering</a></div> */}
              <div className="major"><strong>Bachelor of Technology</strong> - Computer Science</div>
              {/* <div className="minor"><strong>Minor:</strong> Interaction Design</div> */}
              {/* <div className="conc"><strong>Concentration:</strong> Human Computer Interaction</div> */}
              {/* <div className="study-abroad"><strong>Study Abroad:</strong> Experience Design of Travel in Budapest, Hungary</div> */}
              <div className="grad-date">April - 2007</div>
            </div>
          </div>
          <div className="experience">
            <h4>Experience</h4>
            <div className="content">
              <div className="exp-item">
                <div className="job">
                  <a className="company" href="https://capillarytech.com/" target="_blank" rel="noopener noreferrer">Capillary Technologies</a>
                  <div className="duration">January 2016 &mdash; Present</div>
                </div>
                <div className="title">Software Development Engineer - II</div>
                <ul className="description">
                  <li>Provided expert guidance and hands-on development for project GRD4 (PizzaHut - MENA Region), a progressive web app</li>
                  <li>Delivered initial POC using existing API's in a very aggressive timeline which played a crucial role in acquisition of project, competed by four vendors world-wide</li>
                  <li>Re-architected the existing cassandra solution to include custom types</li>
                  <li>Worked on several POC's (GraphQL, React, Angular2, OData, Redis) in the process of choosing the best tech stack</li>
                  <li>Provided technical leadership to the team and solved several problems during the course of the project</li>
                </ul>
              </div>
              <div className="exp-item">
                <div className="job">
                  <a className="company" href="http://infosagesystems.com/" target="_blank" rel="noopener noreferrer">InfoSage Systems</a>
                  <div className="duration">November 2010 &mdash; December 2015</div>
                </div>
                <div className="title">Senior Software Engineer</div>
                <ul className="description">
                  <li>Involved in design, development and management of several projects in healthcare, telecommunication and e-commerce domains</li>
                  <li>Worked closely with the stakeholders in gathering requirements and prioritizing</li>
                  <li>Adopted agile practices to streamline the development</li>
                </ul>
              </div>
              <div className="exp-item">
                <div className="job">
                  <a className="company" href="http://conceptwaves.com/" target="_blank" rel="noopener noreferrer">ConceptWaves</a>
                  <div className="duration">August 2008 &mdash; November 2010</div>
                </div>
                <div className="title">Software Engineer</div>
                <ul className="description">
                  <li>Actively involved in development of an existing java based product "TuningFork"</li>
                  <li>Redesigned the entire application’s GUI for better usability</li>
                  <li>Worked on apache struts and hibernate frameworks</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="projects">
            <h4>Projects</h4>
            <div className="content">
              <div className="project-item">
                <a className="project-title">PizzaHut(Middle East)</a>
                <p className="project-desc">A single page progressive webapp built using Angular 4, consumes MarJack's frontend API's</p>
              </div>
              <div className="project-item">
                <a className="project-title">US Recruitment Agency Application</a>
                <p className="project-desc">A complete application to manage all the office related activities from creating emails for employees to generating payrolls based on Node JS, Mongo DB, CSS3, JavaScript. Uses Haraka.js for emails and twilio for audio calls.</p>
              </div>
              <div className="project-item">
                <div className="project-title">Poker Club Management</div>
                <p className="project-desc">A realtime mobile application that manages poker club finances and generates reports on demand. Built using MeteorJS, ported to android using Cordova.</p>
              </div>
              <div className="project-item">
                <a className="project-title">Aspect Telephony Client</a>
                <p className="project-desc">A html5, WEB-RTC based framework that plugs in to existing telephony architecture and communicates with Aspect UIP platform</p>
              </div>
              <div className="project-item">
                <div className="project-title">Lollipop Stories</div>
                <p className="project-desc">A mobile app for both iOS and Android that plays children's audio stories on demand. Launched by Mr. S.P.Balasubrahmanyam.</p>
              </div>
              <div className="project-item">
                <a className="project-title" href="http://ashwinkumar.co/" target="_blank" rel="noopener noreferrer">ashwinkumar.co</a>
                <p className="project-desc">Online resume built using react, meets all the progressive web app standards.</p>
              </div>
            </div>
          </div>
          <a className="resume" href={this.props.resumeURL} target="_blank" rel="noopener noreferrer"><div className="resume-link">Grab a PDF of my full resume</div></a>
        </div>
      </div>
    );
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/app/components/resume.js